/**
 * Mascot — "peeking" pose.
 * 3D render (Blender, see scripts/mascot/cat_blender.py): head and paws over an
 * edge. Used for empty states, onboarding, and 404 pages.
 */
export function CatPeeking({ className = '', size = 200 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size * 0.55}
      viewBox="0 0 240 132"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Uptrack cat mascot peeking curiously"
    >
      <image href="/mascot/cat-peeking.webp" width="240" height="132" />
    </svg>
  )
}
